export const selectOrder = (state) => state.order
export const selectOrderLenderLogo = (state) => selectOrder(state).lender_logo
export const selectDoingBusinessAs = (state) => selectOrder(state).doing_business_as || {}
export const selectOrderBranchLogo = (state) => selectDoingBusinessAs(state).email_logo
